import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router/index';
import App from './App'
import axios from '../src/plugin/axios'
import api from '../src/service/api/repository/index'
import host from '../src/service/api/api-const'
import Cookies from 'vue-cookie'
import store from './store'
import { restoreFromCookie } from './store/utils'
import $ from 'jquery'
import Base64 from 'js-base64';
import util from './libs/util'
import vueSignature from "vue-signature"
import Py from './libs/py'
import 'mint-ui/lib/style.css'
import * as lrz from './libs/lrz.bundle'

import config from "../static/js/config"  
console.log(config)
import dateTime from 'vue-date-time-m';
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Group from 'vux/src/components/group/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Search from 'vux/src/components/search/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import DatetimeView from 'vux/src/components/datetime-view/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.prototype.$http = axios
Vue.use(Cookies)
Vue.use(Base64)
Vue.use(lrz)
Vue.use(ToastPlugin)
Vue.component('vueSignature', vueSignature)
Vue.use(LoadingPlugin)
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
Vue.component('group', Group)
Vue.component('cell', Cell)
Vue.component('cell-box', CellBox)
Vue.component('x-button', XButton)
Vue.component('x-input', XInput)
Vue.component('selector', Selector)
Vue.component('button-tab', ButtonTab)
Vue.component('button-tab-item', ButtonTabItem)
Vue.component('checker', Checker)
Vue.component('checker-item', CheckerItem)
Vue.component('x-dialog', XDialog)
Vue.component('toast', Toast)
Vue.component('search', Search)
Vue.component('x-table', XTable)
Vue.component('load-more', LoadMore)
Vue.component('grid', Grid)
Vue.component('grid-item', GridItem)
Vue.component('group-title', GroupTitle)
Vue.component('icon', Icon)
Vue.component('x-icon', Icon)
Vue.component('popup-picker', PopupPicker )
Vue.component('msg', Msg )
Vue.component('datetime', Datetime )
Vue.component('x-textarea', XTextarea )
Vue.component('panel', Panel )
Vue.component('scroller', Scroller )
Vue.component('datetime-view', DatetimeView )
Vue.component('tab', Tab )
Vue.component('tab-item', TabItem )
Vue.component('x-img', XImg )
Vue.component('confirm', Confirm )
Vue.directive('transfer-dom', TransferDom)
Vue.component('x-header', XHeader)
Vue.component('data-time', dateTime);


window.host = host
window.axios = axios
window.Api = api
window.py = Py
window.Util = util
window.Conf = config


restoreFromCookie(
store,
{ module: 'app', mutation: 'SET_USER_INFO' },
{ token: 'token', id: 'id', store_id: 'store_id' },
Vue.cookie
)

FastClick.attach(document.body)
Vue.config.productionTip = false

Vue.directive('drag',
{bind:function (el, binding) {
let oDiv = el;
var flag = false;
var cur = {
x:0,
y:0
}
var nx,ny,dx,dy,x,y ;
function down(){
flag = true;
var touch ;
if(event.touches){
touch = event.touches[0];
}else {
touch = event;
}
cur.x = touch.clientX;
cur.y = touch.clientY;
dx = oDiv.offsetLeft;
dy = oDiv.offsetTop;
return false
}
function move(){
if(flag){
var touch ;
if(event.touches){
touch = event.touches[0];
}else {
touch = event;
}
nx = touch.clientX - cur.x;
ny = touch.clientY - cur.y;
x = dx+nx;
y = dy+ny;
if (x < 0) {
x = 0;
}else if (x > document.documentElement.clientWidth - oDiv.offsetWidth) {
x = document.documentElement.clientWidth - oDiv.offsetWidth;
}
if (y < 0) {
y = 0;
}else if (y > document.documentElement.clientHeight - oDiv.offsetHeight) {
y = document.documentElement.clientHeight - oDiv.offsetHeight;
}
oDiv.style.left = x+"px";
oDiv.style.top = y +"px";

document.addEventListener("touchmove",function(){
event.preventDefault();
},false);
return false
}
}

function end(){
flag = false;
}
oDiv.addEventListener("mousedown",function(){
down();
},false);
oDiv.addEventListener("touchstart",function(){
down();
},false)
oDiv.addEventListener("mousemove",function(){
move();
},false);
oDiv.addEventListener("touchmove",function(){
move();
},false)
document.body.addEventListener("mouseup",function(){
end();
},false);
oDiv.addEventListener("touchend",function(){
end();
},false);
}
}
);
new Vue({
router,
store,
axios,
render: h => h(App)
}).$mount('#app-box')




// WEBPACK FOOTER //
// ./src/main.js